import { DateTime, Duration } from 'luxon';

import FormSendInquiryEmail, {
  SendInquiryEmailFormData,
} from 'dashboard/forms/FormSendInquiryEmail';
import { ModalBody, ModalContainer, ModalHeader } from 'dashboard/layouts/ModalLayout';
import { Environment } from 'dashboard/models/environment';
import {
  DAYS_HOURS_MINUTES_HUMAN_FORMAT,
  HOURS_MINUTES_HUMAN_FORMAT,
} from 'lib/constants/luxonFormats';

interface SendInquiryEmailModalProps {
  handleCancel: () => void;
  handleSendInquiryEmail: (values: SendInquiryEmailFormData) => void;
  emailAddress: string;
  currentEnvironment: Environment;
  expiresAt: string | undefined;
}

const SendInquiryEmailModal = ({
  handleCancel,
  handleSendInquiryEmail,
  emailAddress,
  currentEnvironment,
  expiresAt,
}: SendInquiryEmailModalProps) => {
  const expirySeconds = expiresAt
    ? DateTime.fromISO(expiresAt).diff(DateTime.now(), 'seconds').seconds
    : 86400;
  const durationFormat =
    expirySeconds > 86400 ? DAYS_HOURS_MINUTES_HUMAN_FORMAT : HOURS_MINUTES_HUMAN_FORMAT;
  return (
    <ModalContainer data-test='send-inquiry-email-modal'>
      <ModalHeader data-test='send-inquiry-email-modal__header' onClose={handleCancel}>
        Email inquiry link
      </ModalHeader>
      <ModalBody>
        <FormSendInquiryEmail
          handleCancel={handleCancel}
          initialValues={{
            'email-address': emailAddress,
            'email-subject': 'Verify your identity',
            'email-greeting': 'Please verify your identity',
            'email-body': `Click the link below and complete the identity verification process within ${Duration.fromObject(
              { seconds: expirySeconds },
            ).toFormat(durationFormat)}.`,
            'email-cta': 'Verify identity',
          }}
          onSubmit={handleSendInquiryEmail}
          currentEnvironment={currentEnvironment}
        />
      </ModalBody>
    </ModalContainer>
  );
};

export default SendInquiryEmailModal;
